<template>
  <div class="flex-1 flex flex-col w-1/2 h-full" :class="classes">
    <div class="h-full border-r">
      <div
        v-if="loading"
        class="flex-1 flex flex-col justify-center align-center"
      >
        <spinner size="large"></spinner>
      </div>

      <textarea :id="name"></textarea>
    </div>
  </div>
</template>

<script>
import "codemirror/addon/fold/foldgutter.css";
import "codemirror/theme/dracula.css";

require('codemirror/keymap/sublime');
require('codemirror/addon/comment/comment');
require('codemirror/addon/search/searchcursor');
require('codemirror/addon/fold/foldcode');
require('codemirror/addon/fold/foldgutter');
require('codemirror/addon/fold/indent-fold');
require('codemirror/addon/fold/brace-fold');
require('codemirror/mode/htmlmixed/htmlmixed');
require('codemirror/mode/xml/xml');
require('codemirror/mode/clike/clike');
require('codemirror/mode/php/php');

const CodeMirror = require('codemirror/lib/codemirror');

import Spinner from 'vue-simple-spinner'


function findGetParameter(parameterName) {
    var result = null,
        tmp = [];
    location.search
        .substr(1)
        .split("&")
        .forEach(function (item) {
          tmp = item.split("=");
          if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
        });
    return result;
}

export default {
  name: 'Editor',
  components: {
    Spinner,
  },
  props: {
    name: String,
    documentationProperty: String,
    defaultCode: String,
    classes: String,
    value: String,
    loading: Boolean,
  },
  data () {
    return {
      unsubscriber: null,
      code: this.value,
      timeout: null,
      editor: null,
      editorOptions: {
        lineNumbers: true,
        lineWrapping: false,
        theme: 'dracula',
        keyMap: "sublime",
        gutters: ["CodeMirror-linenumbers", "CodeMirror-foldgutter"],
        foldGutter: true,
        mode: 'text/x-php',
        lineWrapping: true,
      },
    }
  },

  computed: {
    theme() {
      return this.$store.state.Code.theme;
    },
    lineHeight() {
      return this.$store.state.Code.lineHeight;
    },
    fontSize() {
      return this.$store.state.Code.fontSize;
    },
    font() {
      return this.$store.state.Code.font;
    },
    lineNumbers() {
      return this.$store.state.Code.lineNumbers;
    },
    lineWrapping() {
      return this.$store.state.Code.lineWrapping;
    }
  },

  watch: {
    theme(value) {
      this.editor.setOption("theme", value.toLowerCase());
      this.editor.refresh();
    },
    lineHeight(value) {
      this.editor.getWrapperElement().style.lineHeight = value;
      this.editor.refresh();
    },
    fontSize(value) {
      this.editor.getWrapperElement().style.fontSize = value+"px";
      this.editor.refresh();
    },
    font(value) {
      this.editor.getWrapperElement().style.fontFamily = value;
      this.editor.refresh();
    },
    lineNumbers(value) {
      this.editor.setOption("lineNumbers", value);
    },
    lineWrapping(value) {
      this.editor.setOption("lineWrapping", value);
    }
  },

  methods: {

    loadSettings() {
      this.editor.setOption("theme", this.theme.toLowerCase());
      this.editor.getWrapperElement().style.lineHeight = this.lineHeight;
      this.editor.getWrapperElement().style.fontSize = this.fontSize+"px";
      this.editor.setOption("lineNumbers", this.lineNumbers);
      this.editor.setOption("lineWrapping", this.lineWrapping);
      this.editor.refresh();
    },

  },

  beforeDestroy() {
    this.unsubscriber();
  },

  mounted() {
    this.editor = CodeMirror.fromTextArea(document.getElementById(this.name), this.editorOptions);

    this.editor.on("change", (cm) => {
      if (cm.getValue() !== this.defaultCode) {
        this.$store.dispatch("setIsDirty", true);
      }

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.$emit('input', cm.getValue())
      }, 350);
    });

    this.editor.getWrapperElement().style.fontFamily = 'Fira Code';

    this.editor.getDoc().setValue(this.defaultCode);
    this.$emit('input', this.defaultCode);

    this.editor.refresh();

    this.loadSettings();

    this.unsubscriber = this.$store.subscribe((mutation, state) => {
      if (mutation.type === 'tryCodeFromDocumentation') {
        if (mutation.payload[this.documentationProperty]) {
          this.editor.getDoc().setValue(mutation.payload[this.documentationProperty]);
          this.editor.refresh();

          this.$store.dispatch("setIsDirty", false);

          setTimeout(() => {
            this.$root.$emit('php.run.tinkerwell');
          }, 150);
        }
      }
      if (mutation.type === 'loadSnippet') {
        if (mutation.payload[this.documentationProperty]) {
          this.editor.getDoc().setValue(mutation.payload[this.documentationProperty]);
          this.editor.refresh();

          this.$store.dispatch("setIsDirty", false);
        }
      }
    });

    this.$root.$on('php.loaded', () => {
      this.phpLoaded = true;

      try {
        const preloadCode = findGetParameter("code");
        if (preloadCode === null) {
          return;
        }
        const decodedCode = atob(decodeURIComponent(preloadCode));
        
        this.$store.dispatch("setPreference", {
          key: "autoEvaluate",
          value: false,
        })

        this.editor.getDoc().setValue(decodedCode);
        return;
      } catch (err) {
        //
      }
    });
  }
}
</script>

<style scoped>
.vue-codemirror {
  width: 100% !important;
  height: 100% !important;
}
</style>

<style>
.CodeMirror {
  height: 100% !important;
  width: 100% !important;
}
.cm-s-github.CodeMirror {
  background: #fff;
  color: #24292e;
}

.cm-s-github .CodeMirror-gutters {
  background: #fff;
  border: 0;
}

.cm-s-github .CodeMirror-linenumber {color: rgba(27, 31, 35, 0.3);}
.cm-s-github .CodeMirror-cursor {border-color: #24292e;}

.cm-s-github .cm-keyword {color: #d73a49;}
.cm-s-github .cm-atom {color: #005cc5;}
.cm-s-github .cm-number {color: #005cc5;}
.cm-s-github .cm-def {color: #d73a49;}
.cm-s-github .cm-variable {color: #24292e;}
.cm-s-github .cm-variable-2 {color: #d73a49;}
.cm-s-github .cm-variable-3,
.cm-s-default .cm-type {color: #6f42c1;}
.cm-s-github .cm-property {color: #005cc5;}
.cm-s-default .cm-punctuation,
.cm-s-default .cm-operator {}
.cm-s-github .cm-comment {color: #6a737d;}
.cm-s-github .cm-string {color: #005cc5;}
.cm-s-github .cm-string-2 {color: rgba(46,56,60,1);}
.cm-s-github .cm-meta {color: #24292e;}
.cm-s-github .cm-qualifier {color: #6f42c1;}
.cm-s-github .cm-builtin {color: #6f42c1;}
.cm-s-github .cm-bracket {color: #24292e;}
.cm-s-github .cm-tag {color: #22863a;}
.cm-s-github .cm-attribute {color: #6f42c1;}
.cm-s-github .cm-attribute + .cm-s-github .cm-string {color: #032f62;}
.cm-s-github .cm-hr {color: #24292e;}
.cm-s-github .cm-link {color: #005cc5;}

.cm-s-github .cm-error {color: #d73a49;}
.cm-invalidchar {color: #d73a49;}

</style>
